<template>
	<div class="industry-page">

		<section class="industry-hero">
			<div class="industry-content center-content">
				<h1>Industries & Applications</h1>
				<p>
					Fathom Ocean delivers underwater visibility for research, conservation,
					infrastructure, public engagement, and waterfront monitoring.
				</p>
			</div>
		</section>

		<section class="industry-section application-portfolio">
			<div class="industry-content">
				<div class="pink-line"></div>

				<div class="industry-grid">
					<div class="industry-card">
						<h2>Research & Conservation</h2>
						<h3>Understand Ecosystems in Real Time</h3>
						<p>
							Observe marine environments continuously without disrupting natural behavior.
						</p>
						<ul>
							<li>Species monitoring</li>
							<li>Behavioral studies</li>
							<li>Habitat assessment</li>
							<li>Public outreach</li>
							<li>Long-term ecosystem observation</li>
						</ul>
					</div>

					<div class="industry-card">
						<h2>Utilities & Infrastructure</h2>
						<h3>Protect Critical Assets Below the Surface</h3>
						<p>
							Monitor cooling water intakes, marine growth, underwater structures,
							and environmental compliance requirements.
						</p>
						<ul>
							<li>Power generation facilities</li>
							<li>Ports</li>
							<li>Municipal infrastructure</li>
							<li>Industrial facilities</li>
						</ul>
					</div>

					<div class="industry-card">
						<h2>Marinas & Yacht Clubs</h2>
						<h3>Transform Your Waterfront Experience</h3>
						<p>
							Give members and guests a live view of the underwater world.
						</p>
						<ul>
							<li>Member engagement</li>
							<li>Educational programming</li>
							<li>Environmental stewardship</li>
							<li>Marketing content</li>
							<li>Visitor attraction</li>
						</ul>
					</div>

					<div class="industry-card">
						<h2>Waterfront Homes</h2>
						<h3>Your Private Window Into the Ocean</h3>
						<p>
							Watch fish, rays, turtles, dolphins, and other marine visitors in real time.
						</p>
						<ul>
							<li>Remote viewing</li>
							<li>Family entertainment</li>
							<li>Marine education</li>
							<li>Property enhancement</li>
							<li>Low maintenance operation</li>
						</ul>
					</div>
				</div>
			</div>
		</section>

		<section class="industry-section platform-story">
			<div class="industry-content feature-grid">
				<div>
					<h2>Many Cameras, One Monitoring Platform</h2>
					<p>
						Plug-and-play cameras seamlessly connect to the Periscope AI platform for
						secure real-time viewing, recording, and administration.
					</p>
				</div>

				<div>
					<img class="feature-image" src="@/assets/images/computer_ipad.png" alt="Periscope AI platform" loading="lazy" decoding="async">
				</div>
			</div>
		</section>

		<section class="industry-section system-family">
			<div class="industry-content">
				<div class="pink-line"></div>
				<h2>Fathom Systems</h2>

				<div class="systems-grid">

					<div class="system-card system-card--angler">
						<img src="@/assets/images/angler-product.png" alt="Angler" loading="lazy" decoding="async">
						<h3>Angler™</h3>
						<p>Fixed-view, self-cleaning underwater monitoring.</p>
					</div>

					<div class="system-card system-card--octopus">
						<img src="@/assets/images/octopus-product.png" alt="Octopus" loading="lazy" decoding="async">
						<h3>Octopus™</h3>
						<p>Pan-tilt-zoom underwater observation for advanced deployments.</p>
					</div>
						
					<div class="system-card system-card--periscope">
						<img src="@/assets/images/Periscope_app_mock_industrial_monitor 2.png" alt="Periscope AI" loading="lazy" decoding="async">
						<h3>Periscope AI™</h3>
						<p>Centralized monitoring, recording, alerts, and analytics.</p>
					</div>
				</div>
			</div>
		</section>

		<section class="industry-section consult-section center-content">
			<div class="industry-content">
				<h2>See Fathom in Action</h2>
				<p class="large-copy">
					Learn how Fathom delivers modular, cost-effective underwater monitoring
					solutions to businesses and organizations around the world.
				</p>

				<b-button @click="$router.push('/contact')">
					Get in Touch
				</b-button>
			</div>
		</section>

	</div>
</template>

<script>
export default { name: 'Industry' }
</script>
